import { PersonDto } from '../../person/models/PersonDto'
import { CandidateRankedDto } from './CandidateDto'

export type RoleDto = {
    id: string
    jobTitle: string
    searchTerm?: string
    status?: RoleProcessingStatus
    candidatePoolCount?: number
    closenessCalculationProgress?: number
    proximityBoundaryProgress?: number
    jobRelevanceCalculationProgress?: number
    candidateRankingProgress?: number
    errorMsg?: string
    startDate?: Date
    completedDate?: Date
    hiringTeam?: PersonDto[]
    candidates?: CandidateRankedDto[]
    excludedCandidates?: CandidateRankedDto[]
}

export type RoleLiteDto = {
    id: string
    jobTitle: string
    searchTerm?: string
    status?: RoleProcessingStatus
    candidatePoolCount?: number
    closenessCalculationProgress?: number
    proximityBoundaryProgress?: number
    jobRelevanceCalculationProgress?: number
    candidateRankingProgress?: number
    errorMsg?: string
    startDate?: Date
    completedDate?: Date
    hiringTeamIds?: string[]
    networkLinkIds?: string[]
    companyLinkIds?: string[]
}

export enum RoleProcessingStatus {
    NOT_STARTED = 'NOT_STARTED',
    GATHERING_CANDIDATES = 'GATHERING_CANDIDATES', // selecting WORKED_WITH rels
    CALC_PROXIMITY_BOUNDARIES = 'CALC_PROXIMITY_BOUNDARIES', // calculating MAX and MIN for closeness
    GENERATING_NETWORK = 'GENERATING_NETWORK', // calculating closeness
    CALC_JOB_RELEVANCE = 'CALC_JOB_RELEVANCE', // calculating job relevance
    FINDING_BEST_CANDIDATES = 'FINDING_BEST_CANDIDATES', // calculating overall ranking scores
    COMPLETE = 'COMPLETE',
    ERROR = 'ERROR',
}
